import _ from 'lodash';

import { Authority, getTranslatedString } from "@skinsoft/types";

export const linkedAccount = (authority: Authority): string => {
    return _.get(authority, 'authorityCS.linkedAccount.ref') ??
    _.get(authority, 'authorityCS.linkedAccount')
}

export const firstAlias = (authority: Authority) => {
    return _.get(authority, 'authorityCS.aliasesFirst') ?? 
    _.get(authority, 'authorityCS.alias[0]', null) ?? 
    _.get(authority, 'alias[0]', null)
}

export const firstAliasCompleteValue = (authority: Authority, locale: string) => {
    const alias = firstAlias(authority)
    const value = _.get(alias, 'completeValue')
    return value ? getTranslatedString(value, locale) : ''
}